import { ActiveStep } from "components/stepper/use-active-step";

export function getStepperProgressPercentage(activeStep: ActiveStep) {
    const allSteps = [
        {
            condition: activeStep === ActiveStep.Guests,
            percentage: 0,
        },
        {
            condition: activeStep === ActiveStep.GuestsChildren,
            percentage: 25,
        },
        {
            condition: activeStep === ActiveStep.Date,
            percentage: 40,
        },
        {
            condition: activeStep === ActiveStep.Availability,
            percentage: 75,
        },
        {
            condition: activeStep === ActiveStep.Preorder,
            percentage: 85,
        },
        { condition: activeStep === ActiveStep.Finalize, percentage: 100 },
    ].filter(Boolean);

    return allSteps.reverse().find((step) => step?.condition)?.percentage ?? 0;
}
